// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"e5631450","189":"64e30c7c","447":"915abc99","470":"de210c0a","550":"862ffe44","583":"1c59f74b","828":"915abc99","988":"a860f827"}[chunkId] + ".chunk.css";
};